import {Injectable} from '@angular/core';
import {AppSettings} from '../models/Constants';
import {FeatureFlag} from '../models/FeatureFlag';
import {themeSwitcher, ThemeVariant} from '@siemens/ix-angular';
import {
  brandDark,
  brandLight,
  classicDark,
  classicLight,
} from '@siemens/ix-echarts';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  setTheme(features?: FeatureFlag) {
    const variant = sessionStorage.getItem('variant') || 'dark';
    this.setThemeVariables(variant as ThemeVariant, features);

    themeSwitcher.schemaChanged.on((changedVariant) => {
      sessionStorage.setItem('variant', changedVariant);
      if (
        this.themeHasChanged(
          features?.organizationTheme,
          sessionStorage.getItem('theme'),
        )
      ) {
        this.setThemeVariables(changedVariant as ThemeVariant, features);
      }
    });

    themeSwitcher.setTheme(sessionStorage.getItem('theme') ?? 'brand');
    themeSwitcher.setVariant(
      (sessionStorage.getItem('variant') ?? 'dark') as ThemeVariant,
    );
  }

  themeHasChanged(
    orgTheme: {lightTheme: string; darkTheme: string} | undefined,
    currentTheme: string | null,
  ): boolean {
    return (
      orgTheme?.darkTheme !== currentTheme &&
      orgTheme?.lightTheme !== currentTheme
    );
  }

  setThemeVariables(variant: ThemeVariant, feature?: FeatureFlag): void {
    const isDark = variant === 'dark';
    const theme = feature?.organizationTheme;
    const orgThemeString =
      theme && (isDark ? theme.darkTheme : theme.lightTheme);
    const themeString = orgThemeString || AppSettings.DARK_THEME_DEFAULT;
    sessionStorage.setItem('theme', themeString.split('-')[1]);
  }

  get actualVariant(): ThemeVariant {
    return (sessionStorage.getItem('variant') || 'dark') as ThemeVariant;
  }

  get actualTheme(): string {
    return sessionStorage.getItem('theme') || 'brand';
  }

  get actualChartTheme() {
    const isBrand = this.actualTheme === 'brand';
    const isDark = this.actualVariant === 'dark';

    if (isBrand) {
      return isDark ? brandDark.theme : brandLight.theme;
    }
    return isDark ? classicDark.theme : classicLight.theme;
  }
}
